module.exports = __webpack_public_path__ + "static/media/2playerRoomsPlayed_100_250.cb4978f4.png";